
import { mapGetters, mapActions } from 'vuex'
export default {
  head: {
    title: 'Create Gift Certificate ∙ Pen The Journey',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Create a gift certificate for use on any product in the store!',
      },
      //Facebook Open Graph Tags
      {
        hid: 'og:url',
        property: 'og:url',
        content: 'https://penthejourney.com/giftcertificates/',
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Gift Certificates ∙ Pen The Journey',
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content:
          'Create a gift certificate for use on any product in the store!',
      },
      {
        hid: 'og:site_name',
        property: 'og:site_name',
        content: 'Pen The Journey',
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: 'https://penthejourney.com/2.png',
      },
      {
        hid: 'og:image:type',
        property: 'og:image:type',
        content: 'image/jpg',
      },
      { hid: 'og:image:height', property: 'og:image:height', content: '720' },
      { hid: 'og:image:width', property: 'og:image:width', content: '720' },
      { hid: 'og:image:alt', property: 'og:image:alt', content: '' },
      { hid: 'og:type', property: 'og:type', content: 'website' },
      //Twitter tags
      {
        hid: 'twitter:card',
        name: 'twitter:type',
        content: 'summary_large_image',
      },
      {
        hid: 'twitter:url',
        name: 'twitter:url',
        content: 'https://penthejourney.com/giftcertificates/',
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: 'Gift Certificates ∙ Pen The Journey',
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content:
          'Create a gift certificate for use on any product in the store!',
      },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: 'https://penthejourney.com/2.png',
      },
      { hid: 'twitter:image:alt', name: 'twitter:image:alt', content: '' },
    ],

    link: [
      {
        rel: 'canonical',
        href: 'https://penthejourney.com/giftcertificates/',
      },
    ],
  },
  data() {
    return {
      isAddingToCart: false,
      cert: {
        //this is done to match the existing way products like planners etc have their schemea set up
        personalizedText: '',
        itemTotal: 0,
        product: {
          name: 'Gift Card',
          senderName: '',
          recipientEmail: '',
          cost: 0,
          value: '',
          id: '',
          message: '',
          dateRedeemed: null,
          dateCreated: null,
          isRedeemed: false,
          orderIdRedeemedOn: null,
        },
      },
    }
  },
  methods: {
    ...mapActions('cart', ['addToVuexCart']),
    async addGcToCart() {
      try {
        const { cert } = this;
        cert.itemTotal = cert.product.cost;
        this.isAddingToCart = true;
        await this.addToVuexCart({...cert});
        this.isAddingToCart = false;
        this.$notify({text: 'Cart addition successful', type: 'success'});
      } catch (error) {
        this.isAddingToCart = false;
        console.error(error);
        this.$notify({text: error, type: "error"})
      }
    },
  },
}
